module.exports = "https://bin.bnbstatic.com/_next/static/images/labs-78a7adb9e083495a9021a7324f8086fb.png";